<template>
	<div class="mx-auto h-100 text--primary pb-12 border-0" color="transparent" elevation="0" v-if="order">
		<order-card :order="order" :show-actions="false" />

		<v-card v-if="payment" class="mx-auto mt-2">
			<v-table dense class="my-0 py-0">
				<thead>
					<tr>
						<th class="text-left">类型</th>
						<th class="text-left">金额</th>
						<th class="text-left">数量</th>
						<th class="text-left">ID</th>
					</tr>
				</thead>
				<tbody>
					<tr v-for="(pi, index) in payment.items" :key="pi.id">
						<td>{{ pi.type }}</td>
						<td>￥{{ pi.amt }}</td>
						<td>{{ pi.qty }}</td>
						<td>{{ pi.ids }}</td>
					</tr>
				</tbody>
			</v-table>
		</v-card>
	</div>
</template>

<script>
import OrderCard from './Card.vue'

export default {
	props: { value: { type: [String, Object], required: true } },
	data() {
		return {
			order: null,
			qrDlg: false,
			debugging: false,
			payment: null
		}
	},
	computed: {
		paymentMap() {
			let map = {}
			for (let item of this.payment.items) {
				map[item.paytype] = item.amt
			}
			return map
		}
	},
	watch: {
		value: {
			handler: function (val) {
				if (typeof val === 'string') {
					this.$api.order.getDetail(val, (res) => {
						this.order = res
					})
				} else {
					this.order = val
				}
			},
			immediate: true
		}
	},
	mounted() {
		if (typeof this.value === 'string') {
			this.$api.order.getDetail(this.value, (res) => {
				this.order = res
			})
		} else {
			this.order = this.value
		}
		this.getPayment()
	},
	methods: {
		onCopiedToCB(e) {
			alert(this.$t(`common.copied_to_cb`))
		},
		getPayment() {
			this.$api.order.getPayment(this.order.id, (payment) => {
				this.payment = payment
			})
		}
	},
	components: { OrderCard }
}
</script>
<style scoped></style>
